import { render, staticRenderFns } from "./SyncCreatedTable.vue?vue&type=template&id=487ec01e"
import script from "./SyncCreatedTable.vue?vue&type=script&lang=ts"
export * from "./SyncCreatedTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports